const TAB_MIN_HEIGHT = 46;

export const MuiTabs = {
  styleOverrides: {
    root: {
      backgroundColor: 'var(--mui-palette-tab-inactive)',
      minHeight: TAB_MIN_HEIGHT,
    },
    flexContainer: {
      alignItems: 'stretch',
      '.MuiTab-root:only-of-type': {
        flex: '0 0 50%',
        maxWidth: '50%',
        minWidth: '50%',
      },
      // Divider on the right of an unselected tab only when the next tab is also unselected.
      '.MuiTab-root:not(.Mui-selected):has(+ .MuiTab-root:not(.Mui-selected))':
        {
          borderRight: '1px solid var(--mui-palette-tab-divider)',
        },
    },
    indicator: {
      display: 'none',
    },
  },
};
